export const getDictValue = (searchKey, dictionary) => {
    if (!dictionary && !searchKey)
        return "";
    if (!searchKey)
        return "";
    if (!dictionary)
        return searchKey;
    const data = dictionary.filter(({ key }) => key === searchKey);
    return data.length && data[0].value ? data[0].value : searchKey;
};
